module.exports = __webpack_public_path__ + "static/media/thereYouGo.a3d00b4f.wav";


//////////////////
// WEBPACK FOOTER
// ./src/audio/thereYouGo.wav
// module id = 520
// module chunks = 0